/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-04T19:46:29.331
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getHouseRepeatPlanConditionEditInit,
	getHouseRepeatPlanConditionView
} from '@api/storagemanage/HouseRepeatPlanCondition';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getHouseRepeatPlanConditionEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseRepeatPlanConditionEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHouseRepeatPlanConditionView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseRepeatPlanConditionView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
